/* unplugin-vue-components disabled */import { render } from "./gscpdslogin.vue?vue&type=template&id=5a8cdde5&scoped=true"
import script from "./gscpdslogin.vue?vue&type=script&lang=js"
export * from "./gscpdslogin.vue?vue&type=script&lang=js"

import "./gscpdslogin.vue?vue&type=style&index=0&id=5a8cdde5&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8cdde5"]])

export default __exports__